__turbopack_context__.v({
  "reviewStar": "ReviewsHeader-module-scss-module__L1cFkW__reviewStar",
  "reviewStarMobile": "ReviewsHeader-module-scss-module__L1cFkW__reviewStarMobile",
  "textColor": "ReviewsHeader-module-scss-module__L1cFkW__textColor",
});
